import React from 'react';
import { EventResultCardProps } from '../types/bot.types';
import { Event } from '../../../modules/SportsAndEventsPage/sportsAndEventsInterface';
import EventCard from '../../EventCard/EventCard';

const EventResultCard: React.FC<EventResultCardProps> = ({
  index, name, venue, city, date, category, minPrice, currency, imageUrl, onSelect,
}) => {
  // Build a minimal Event object that EventCard can render
  const eventObj = {
    id: index,
    identifier: String(index),
    name,
    dateOfEvent: date,
    finalDate: true,
    finalTime: false,
    timeOfEvent: '',
    venue: venue ? { id: 0, name: venue, address: '' } : undefined,
    city: city ? { id: 0, name: city } : undefined,
    country: { id: 0, name: '' },
    minTicketPrice: { price: minPrice, currency },
    availableCategoriesQuantity: 1,
    eventType: category ? { id: 0, name: category } : { id: 0, name: '' },
    tournament: { id: 0, name: '' },
    participants: [],
    homeTeam: { id: 0, name: '' },
    awayTeam: { id: 0, name: '' },
    eventUrl: '',
    galleryImages: imageUrl ? [{ url: imageUrl }] : [],
  } as unknown as Event;

  return (
    <div className="bot-result-card bot-result-card--event">
      <EventCard
        event={eventObj}
        compactView={true}
        onEventSelect={() => onSelect()}
      />
    </div>
  );
};

export default EventResultCard;
